import React from 'react';
import { TypeAnimation } from 'react-type-animation';

const ProfessionAnimation = () => {
  return (
    <TypeAnimation
      sequence={[
        'Brand Expert',
        1000, // Waits 1s
        'Full-Stack Engineer',
        1000, // Waits 1s
        'Mobile App Developer',
        1000, // Waits 1s
        'Futurist',
        1000, // Waits 1s
        'Blockchain & AI/NFC Innovator',
        1000, // Waits 1s
      ]}
      wrapper="span"
      speed={50}
      style={{ display: 'inline-block' }}
      repeat={Infinity}
    />
  );
};

export default ProfessionAnimation;
